import { useState } from "react";
import { PointsExperienceListingOutlet } from "./components";
import { PointsExperienceListingProvider } from "./context/PointsExperienceListingContext";
import { INITIAL_POINTS_EXCHANGE_TYPE_VALUE } from "./constants";
import PointsExchangeHero from "./components/PointsExchangeHero/PointsExchangeHero";
import "./PointsExperienceListing.css";

export default function PointsExchangeListing() {
  const [selectedType, setSelectedType] = useState(INITIAL_POINTS_EXCHANGE_TYPE_VALUE);

  return (
    <PointsExperienceListingProvider value={{ selectedType, setSelectedType }}>
      <div className="bg-background-minimal flex h-full flex-col gap-4">
        <div className="points-exchange-listing-gradient relative isolate flex w-full flex-col gap-5 px-5 pt-10 md:px-20 md:pt-10">
          <PointsExchangeHero />
        </div>
        <div className="flex w-full flex-col gap-8 px-5 pb-10 md:px-20">
          <div className="min-h-[70vh]">
            <PointsExperienceListingOutlet />
          </div>
        </div>
      </div>
    </PointsExperienceListingProvider>
  );
}
